/* src/css/picobel.skeleton.css */
.skeleton.picobel {
  --black: #555;
  --white: #ffffff;
  --grey: #ccc;
  --grey--light: #eee;
  --chrome-focus-blue: #015ecc;
  --progress-height: 32px;
  --progress-inner-height: calc(var(--progress-height) - 2px);
  --skeleton-focus: var(--chrome-focus-blue);
  --skeleton-background: var(--white);
  --skeleton-text: var(--black);
  --skeleton-progress: var(--grey);
  --skeleton-progress-bg: var(--white);
  --skeleton-buffered: var(--grey--light);
}
.skeleton.picobel *,
.skeleton.picobel *:before,
.skeleton.picobel *:after {
  box-sizing: inherit;
}
.skeleton.picobel *:focus {
  outline: 2px solid var(--skeleton-focus);
  outline-offset: 1px;
  border-radius: 2px;
}
.skeleton.picobel {
  font-size: inherit;
  position: relative;
  box-sizing: border-box;
  z-index: 1;
  margin: 10px 0;
  height: 64px;
  border: 1px solid var(--skeleton-text);
}
@keyframes skeleton_background_slide {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 20px 0;
  }
}
.skeleton__loader {
  position: absolute;
  display: none;
  z-index: 5;
  bottom: -1px;
  left: 183px;
  right: 0;
  height: var(--progress-height);
  border-top: 1px solid var(--skeleton-text);
  border-bottom: 1px solid var(--skeleton-text);
  background:
    linear-gradient(
      to right,
      var(--skeleton-background) 50%,
      var(--skeleton-text) 50%);
  background-size: 20px 20px;
  background-repeat: repeat;
  background-position: 0 0;
  animation: skeleton_background_slide linear infinite 0.4s;
}
.skeleton.loading .skeleton__loader {
  display: block;
}
.skeleton__play-pause {
  font-size: 10px;
  border: 1px solid var(--skeleton-text);
  appearance: none;
  width: 64px;
  height: 64px;
  background: var(--skeleton-background);
  position: absolute;
  top: -1px;
  left: -1px;
  cursor: pointer;
}
.skeleton__play-pause__text {
  display: none;
}
.skeleton__play-pause:focus {
  z-index: 3;
}
.skeleton__play-pause:before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-40%, -50%);
  border-top: 10px solid transparent;
  border-left: 12px solid var(--skeleton-text);
  border-bottom: 10px solid transparent;
}
.skeleton__play-pause.playing:before {
  height: 18px;
  width: 16px;
  transform: translate(-50%, -50%);
  border-top: 0;
  border-left: 6px solid var(--skeleton-text);
  border-right: 6px solid var(--skeleton-text);
  border-bottom: 0;
}
.skeleton__wrapper--title-artist {
  padding: 0 10px 0 74px;
  height: 64px;
  background: var(--skeleton-background);
  color: var(--skeleton-text);
  line-height: 1.6;
}
.skeleton__title {
  display: inline-block;
  line-height: 1;
  font-weight: bold;
  font-family: monospace;
}
.skeleton__artist {
  font-family: monospace;
  display: inline-block;
  margin-left: 5px;
  line-height: 1;
}
.skeleton__artist:not(:empty):before {
  content: " \2013  ";
}
.skeleton__wrapper--timer-progress-duration {
  position: absolute;
  bottom: -1px;
  left: 182px;
  right: 0;
  height: 32px;
  border-left: 1px solid var(--skeleton-text);
}
.skeleton__timer,
.skeleton__duration {
  position: absolute;
  bottom: 0;
  z-index: 4;
  text-align: left;
  background: transparent;
  color: var(--skeleton-text);
  line-height: 1;
  pointer-events: none;
  font-size: 14px;
  height: 32px;
  padding: 10px 5px 9px 10px;
  font-family: monospace;
}
.skeleton__timer {
  left: 0;
}
.skeleton__duration {
  right: 0;
  text-align: right;
}
.skeleton.loading .skeleton__timer,
.skeleton.loading .skeleton__duration {
  display: none;
}
.skeleton__progress-slider__wrapper {
  height: var(--progress-height);
  font-size: 10px;
  line-height: 1;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.skeleton__progress-slider__replacement {
  position: relative;
  background: var(--skeleton-background);
  border-top: 1px solid var(--skeleton-text);
  border-bottom: 1px solid var(--skeleton-text);
  height: var(--progress-height);
  overflow: hidden;
}
.skeleton__progress-slider__replacement.focus {
  outline: 2px solid var(--skeleton-focus);
  outline-offset: 1px;
  border-radius: 2px;
  z-index: 3;
}
.skeleton__progress-slider__background {
  transition: width 0.2s;
  height: var(--progress-inner-height);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: var(--skeleton-progress-bg);
}
.skeleton__progress-slider__buffered {
  height: var(--progress-inner-height);
  position: absolute;
  top: 0;
  left: 0;
  background: var(--skeleton-buffered);
}
.skeleton__progress-slider__indicator {
  height: var(--progress-inner-height);
  position: absolute;
  top: 0;
  left: 0;
  background: var(--skeleton-progress);
  width: 0%;
}
.skeleton__progress-slider__playhead {
  width: 8px;
  height: var(--progress-inner-height);
  position: absolute;
  top: 0;
  left: 0%;
  margin-left: -4px;
  background: var(--skeleton-text);
}
.skeleton.loading .skeleton__progress-slider__indicator,
.skeleton.loading .skeleton__progress-slider__playhead {
  display: none;
}
.skeleton__progress-slider__range {
  width: 100%;
  height: var(--progress-height);
  padding: 0;
  margin: 0;
  z-index: 4;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.skeleton__progress-slider__range::-webkit-slider-runnable-track {
  width: 100%;
  height: var(--progress-height);
  cursor: pointer;
}
.skeleton__progress-slider__range::-moz-range-track {
  width: 100%;
  height: var(--progress-height);
  cursor: pointer;
}
.skeleton__progress-slider__range::-ms-track {
  width: 100%;
  height: var(--progress-height);
  cursor: pointer;
}
.skeleton__wrapper--mute-volume {
  position: absolute;
  bottom: -1px;
  left: 62px;
  width: 120px;
  height: 32px;
  z-index: 2;
  border-top: 1px solid var(--skeleton-text);
  border-bottom: 1px solid var(--skeleton-text);
  background: var(--skeleton-background);
  display: flex;
  align-items: center;
}
.skeleton__mute {
  display: block;
  z-index: 2;
  float: left;
  width: 32px;
  height: 32px;
  font-size: 10px;
  color: transparent;
  border: 0;
  appearance: none;
  background: var(--skeleton-background);
  border: 1px solid var(--skeleton-text);
  position: relative;
  cursor: pointer;
  overflow: hidden;
  flex-shrink: 0;
}
.skeleton__mute:before {
  display: block;
  width: 6px;
  height: 6px;
  position: absolute;
  content: "";
  top: 50%;
  right: 50%;
  margin-right: -1px;
  transform: translateY(-50%);
  background: var(--skeleton-text);
}
.skeleton__mute:after {
  display: block;
  width: 5px;
  height: 5px;
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  right: 50%;
  margin-right: -4px;
  border-top: 8px solid transparent;
  border-right: 8px solid var(--skeleton-text);
  border-bottom: 8px solid transparent;
}
.skeleton__mute.muted:before {
  background: var(--skeleton-progress);
}
.skeleton__mute.muted:after {
  border-right-color: var(--skeleton-progress);
}
.skeleton__volume {
  --volume-padding: 6px;
  --volume-height: 20px;
  --volume-width: 76px;
  width: var(--volume-width) + var(--volume-padding) * 2;
  height: var(--volume-height) + var(--volume-padding) * 2;
  padding: var(--volume-padding);
}
.skeleton__volume-label {
  display: none;
}
.skeleton__volume-slider__wrapper {
  width: var(--volume-width);
  height: var(--volume-height);
  position: relative;
}
.skeleton__volume-slider__replacement {
  display: block;
  height: var(--volume-height);
  width: var(--volume-width);
  position: relative;
  left: 0;
  z-index: 3;
  background: var(--skeleton-progress);
  flex-grow: 1;
  float: left;
  transform: rotate(180deg);
}
.skeleton__volume-slider__replacement:after {
  content: "";
  display: block;
  border-right: var(--volume-width) solid var(--skeleton-background);
  border-top: var(--volume-height) solid transparent;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.skeleton__volume-slider__replacement.focus {
  outline: 2px solid var(--skeleton-focus);
  outline-offset: 1px;
  border-radius: 2px;
}
.skeleton__volume-slider__indicator {
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background: var(--skeleton-text);
  width: var(--volume-width);
}
.skeleton__volume-slider__playhead {
  display: none;
}
.skeleton__volume-slider__range {
  width: 100%;
  height: var(--volume-height);
  padding: 0;
  margin: 0;
  position: absolute;
  z-index: 4;
  top: 0;
  left: 0;
  opacity: 0;
}
.skeleton__volume-slider__range::-webkit-slider-runnable-track {
  width: 100%;
  height: var(--volume-height);
  cursor: pointer;
}
.skeleton__volume-slider__range::-moz-range-track {
  width: 100%;
  height: var(--volume-height);
  cursor: pointer;
}
.skeleton__volume-slider__range::-ms-track {
  width: 100%;
  height: var(--volume-height);
  cursor: pointer;
}
/*# sourceMappingURL=picobel.skeleton.css.map */
